module.exports = __webpack_public_path__ + "static/media/Ally_app_1.8db1653b.jpg";